// Action Types
const ACTION_PREFIX = 'onboarding/firstSteps'
const SET_STEP_COMPLETED = `${ACTION_PREFIX}/SET_STEP_COMPLETED`
const SET_ACTIVE_STEP = `${ACTION_PREFIX}/SET_ACTIVE_STEP`
const RESET_STATE = `${ACTION_PREFIX}/RESET_STATE`

const STEP_IDS = {
  SUBSCRIPTION: 0,
  DATA_SELECTION: 1,
  GUIDES: 2,
}

const initialState = {
  completedSteps: [],
  activeStep: null,
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_STEP_COMPLETED:
      const stepIndex = action.stepIndex
      if (state.completedSteps.includes(stepIndex)) {
        return state
      }
      return {
        ...state,
        completedSteps: [...state.completedSteps, stepIndex],
      }

    case SET_ACTIVE_STEP:
      return {
        ...state,
        activeStep: action.stepIndex,
      }

    case RESET_STATE:
      return initialState

    default:
      return state
  }
}

// Action Creators
export const setStepCompleted = (stepIndex) => ({
  type: SET_STEP_COMPLETED,
  stepIndex,
})

export const setActiveStep = (stepIndex) => ({
  type: SET_ACTIVE_STEP,
  stepIndex,
})

export const resetState = () => ({
  type: RESET_STATE,
})

export const getStepCompletionStatus = (firstStepsState, stepIndex, onboardingTesterFinished, isDemo, subscriptions) => {
  const { completedSteps } = firstStepsState

  if (stepIndex === STEP_IDS.SUBSCRIPTION) {
    return subscriptions && subscriptions.length > 0
  }

  if (stepIndex === STEP_IDS.DATA_SELECTION) {
    return onboardingTesterFinished || isDemo
  }

  return completedSteps.includes(stepIndex)
}

export const getActiveStepIndex = (firstStepsState, subscriptions, onboardingTesterFinished, isDemo) => {
  const { completedSteps, activeStep } = firstStepsState

  return activeStep
}

export { STEP_IDS }
